import { createAsyncThunk } from "@reduxjs/toolkit";

import { getOrganizationProjects } from "Api/organizations/projects/getOrganizationProjects.request";

export default createAsyncThunk(
  `organization/member/getOrganizationProjects`,
  (organizationId: string) => getOrganizationProjects(organizationId)
);
